import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import useHttp from "../../../hook/use-http";
import moment from "moment";
import ChartLoader from "./ChartLoader";
import Table from "./Table";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates";
import "./TopFiveSectionTemplate.css";
import WaterMark from "../DashboardMain/WaterMark";
import { useSelector } from "react-redux";
import { selectLoggedInUser } from "../../../redux/userSlice";

function TopFiveSectionTemplate(props) {
  let { title, template_id, show, soarting, gloablfilter, IND } = props;

  const [tableData, setTableData] = useState([]);
  const [sortOrder, setSortOrder] = useState("desc");
  const { isLoading, error, sendReq: fetchData } = useHttp();
  let post_fix = "";

  if (IND === "RANGE") {
    post_fix = "Km";
  }

  const singleVinSelected = (vin) => {
    props.singleVinSelected(vin);
  };

  function compareObjects(object1, object2, key) {
    const obj1 = object1.value;
    const obj2 = object2.value;
    if (obj1 > obj2) {
      return -1;
    }
    if (obj1 < obj2) {
      return 1;
    }
    return 0;
  }

  function compareObjectsAsc(object1, object2, key) {
    const obj1 = object1.value;
    const obj2 = object2.value;
    if (obj1 < obj2) {
      return -1;
    }
    if (obj1 > obj2) {
      return 1;
    }
    return 0;
  }

  const appyDataAsc = (data) => {
    const res_result = data;
    let responce = [];
    if (res_result.length != 0) {
      let temp_result = res_result;
      temp_result.map((obj) => {
        responce.push({
          key: obj.key.vehicleId,
          value: obj.Range.values["50.0"],
        });
      });

      responce.sort((value1, value2) => {
        return compareObjectsAsc(value1, value2, "value");
      });
      responce = responce.slice(0, 5);
      setTableData((prestate) => responce);
    } else {
      setTableData((prestate) => []);
    }
  };

  // const appyDataAscErc = (data) => {
  //   const res_result = data;
  //   let responce = [];
  //   if (res_result.length != 0) {
  //     let temp_result = res_result;
  //     temp_result.map((obj) => {
  //       if(

  //       )
  //       responce.push({
  //         key: obj.key.vehicleId,
  //         value: obj.Range.values["50.0"],
  //       });
  //     });

  //     responce.sort((value1, value2) => {
  //       return compareObjectsAsc(value1, value2, "value");
  //     });
  //     responce = responce.slice(0, 5);
  //     setTableData((prestate) => responce);
  //   } else {
  //     setTableData((prestate) => []);
  //   }
  // };

  const appyDataAsc_erc = (data) => {
    const res_result = data;
    let responce = [];
    if (res_result.length !== 0) {
      let temp_result = res_result;
      temp_result.map((obj) => {
        if (
          obj.discharge_cycle.doc_count > gloablfilter.DISCHARGE &&
          (obj.distanceInKM.value === 0
            ? obj.distanceInKM.value >= gloablfilter.DELTA
            : obj.distanceInKM.value > gloablfilter.DELTA)
        ) {
          responce.push({
            key: obj.key.vehicleId,
            value: obj.Range.values["50.0"],
          });
        }
      });

      responce.sort((value1, value2) => {
        return compareObjectsAsc(value1, value2, "value");
      });

      responce = responce.slice(0, 5);

      setTableData((prestate) => responce);
    } else {
      setTableData((prestate) => []);
    }
  };

  const appyData = (data) => {
    const res_result = data;
    let responce = [];
    if (res_result.length != 0) {
      let temp_result = res_result;
      if (template_id === "collapseThree") {
        temp_result.map((obj) => {
          responce.push({ key: obj.key.vehicleId, value: obj.value.value });
        });
      } else {
        temp_result.map((obj) => {
          responce.push({
            key: obj.key.vehicleId,
            value: obj.Range.values["50.0"],
          });
        });
      }

      responce.sort((value1, value2) => {
        return compareObjects(value1, value2, "value");
      });

      responce = responce.slice(0, 5);
      setTableData((prestate) => responce);
    } else {
      setTableData((prestate) => []);
    }
  };

  const appyData_erc = (data) => {
    const res_result = data;
    let responce = [];
    if (res_result.length !== 0) {
      let temp_result = res_result;
      if (template_id === "collapseThree") {
        temp_result.map((obj) => {
          if (
            obj.discharge_cycle.doc_count > gloablfilter.DISCHARGE &&
            (obj.distanceInKM.value === 0
              ? obj.distanceInKM.value >= gloablfilter.DELTA
              : obj.distanceInKM.value > gloablfilter.DELTA)
          ) {
            responce.push({ key: obj.key.vehicleId, value: obj.value.value });
          }
        });
      } else {
        temp_result.map((obj) => {
          if (
            obj.discharge_cycle.doc_count > gloablfilter.DISCHARGE &&
            obj.distanceInKM.value === 0
              ? obj.distanceInKM.value >= gloablfilter.DELTA
              : obj.distanceInKM.value > gloablfilter.DELTA
          ) {
            responce.push({
              key: obj.key.vehicleId,
              value: obj.Range.values["50.0"],
            });
          }
        });
      }

      responce.sort((value1, value2) => {
        return compareObjects(value1, value2, "value");
      });

      responce = responce.slice(0, 5);
      setTableData((prestate) => responce);
    } else {
      setTableData((prestate) => []);
    }
  };

  useEffect(() => {
    setSortOrder("desc");
    if (loggedInUser.flagForHideShow !== "ERC") {
      fetchData(
        {
          url: API_URL_MAIN + "drivefilter/tabledata",
          body: { filterdata: gloablfilter, IND },
        },
        appyData
      );
    } else {
      fetchData(
        {
          url: API_URL_MAIN + "drivefilter/tabledata_erc",
          body: { filterdata: gloablfilter, IND },
        },
        appyData_erc
      );
    }
  }, [gloablfilter]);

  const filterChnaged = (event) => {
    setSortOrder(event.target.value);
    if (loggedInUser.flagForHideShow !== "ERC") {
      if (event.target.value === "asc")
        fetchData(
          {
            url: API_URL_MAIN + "drivefilter/tabledata",
            body: { filterdata: gloablfilter, IND, soart: event.target.value },
          },
          appyDataAsc
        );
      else
        fetchData(
          {
            url: API_URL_MAIN + "drivefilter/tabledata",
            body: { filterdata: gloablfilter, IND, soart: event.target.value },
          },
          appyData
        );
    } else {
      if (event.target.value === "asc")
        fetchData(
          {
            url: API_URL_MAIN + "drivefilter/tabledata_erc",
            body: { filterdata: gloablfilter, IND, soart: event.target.value },
          },
          appyDataAsc_erc
        );
      else
        fetchData(
          {
            url: API_URL_MAIN + "drivefilter/tabledata_erc",
            body: { filterdata: gloablfilter, IND, soart: event.target.value },
          },
          appyData_erc
        );
    }
  };
  console.log(appyDataAsc);

  const loggedInUser = useSelector(selectLoggedInUser);

  return (
    <>
      <div className="accordion-item">
        <h2 className="accordion-header" id={template_id + "Head"}>
          <div
            className="row"
            style={{ marginRight: "0px", marginLeft: "0px" }}
          >
            <div
              className="col-md-6 col-sm-6 col-6 col-6"
              style={{ padding: "0px" }}
            >
              <div
                // className={`acc_line ${soarting ? "" : ""}`}
                className={
                  loggedInUser.flagForHideShow !== "ERC"
                    ? `acc_line ${soarting ? "" : ""}`
                    : `acc_line mb-2 ${soarting ? "" : ""}`
                }
                style={{ fontSize: "0.43em" }}
                align="left"
              >
                <strong>&nbsp;{title}</strong>
              </div>
            </div>
            <div
              className="col-md-4 col-sm-4 col-lg-4  col-4"
              style={{ padding: "0px" }}
            >
              {soarting && (
                <select
                  onChange={filterChnaged}
                  value={sortOrder}
                  className="form-select dropdownSelect acc_select"
                  aria-label="Default select example"
                >
                  <option value="desc">Top</option>
                  <option value="asc">Bottom</option>
                </select>
              )}
            </div>
            <div
              className="col-md-2 col-sm-2 col-lg-2 col-2"
              style={{ padding: "0px" }}
            >
              {/* <button
                style={{ color: " #000" }}
                className="accordion-button acc_btn"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={"#" + template_id}
                aria-expanded="true"
                aria-controls="collapseOne"
              ></button> */}
            </div>
          </div>
        </h2>
        <div
          id={template_id}
          className={`accordion-collapse collapse ${show ? "show" : ""}`}
          aria-labelledby={template_id + "Head"}
          data-bs-parent="#accordionExample"
        >
          <div className="accordion-body p-2">
            <WaterMark />
            {isLoading ? (
              <ChartLoader />
            ) : (
              <Table
                data={tableData}
                singleVinSelected={singleVinSelected}
                post_fix={post_fix}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default TopFiveSectionTemplate;
